export class AccountConfigModel {
  id: number;
  showComments: boolean;
  showGPS: number;
  intervalLow: number;
  intervalPivot: number;
  intervalHigh: number;
  showClockIn: boolean;
  showPhotos: boolean;
  showPhotoComments: boolean;
  showServices: boolean;
  showScheduledDates: boolean;
  enablePayments: boolean;
  portalLogoUri: string;
  showActualDates: boolean;
  companyInformation: CompanyInformationModel;
  commentEditTimeout: number; // how long the customer has in minutes before he/she is no longer to edit a comment
  cashOnlyInvoicing: boolean;

  constructor(model?: Partial<AccountConfigModel>) {
    Object.assign(this, model);
  }
}

export class CompanyInformationModel {
  CompanyID: number;
  CompanyName: string;
  address: string;
  city: string;
  state: string;
  zip: string;
  country: string;
  phone: string;
  email: string;
  website: string;
  invoiceNote1: string;
  invoiceNote2: string;
  invoiceNote3: string;
  portalLogo: string;

  constructor(model?: Partial<CompanyInformationModel>) {
    Object.assign(this, model);
  }
}

/** Company invoice notes with blanks removed. Shared by the on-screen view and the PDF. */
export function getInvoiceNotes(
  companyInformation?: Partial<CompanyInformationModel> | null,
): string[] {
  if (!companyInformation) {
    return [];
  }

  return [
    companyInformation.invoiceNote1,
    companyInformation.invoiceNote2,
    companyInformation.invoiceNote3,
  ]
    .map((note) => note?.trim())
    .filter((note): note is string => !!note);
}
